export const ATTACHMENT_ADDED_COMMENT_DATE_OPTIONS: Intl.DateTimeFormatOptions =
  {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };

export function shouldCreateAttachmentAutoComment(
  commentUid: string | undefined,
): boolean {
  return !commentUid;
}

export function formatAttachmentAddedComment(
  fileName: string,
  date: Date = new Date(),
): string {
  const formattedDate = new Intl.DateTimeFormat(
    'ru',
    ATTACHMENT_ADDED_COMMENT_DATE_OPTIONS,
  ).format(date);
  return `Добавлен файл ${fileName} ${formattedDate}`;
}
